import { createFileRoute } from '@tanstack/react-router'
import { StaffActivityLog } from '../../../../components/StaffActivityLog'

export const Route = createFileRoute('/desa/$slug/dashboard/log-aktivitas')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffActivityLog desaId={desaId} />
  },
})
